export default __webpack_public_path__ + "static/media/blog01.f1b14cd5.jpg";